import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles(() => ({
    bb0: {
        border: 0,
        background: 0
    },
    pointer: {
        cursor: 'pointer'
    },
    text_decor_none: {
        textDecoration: 'none'
    },
    h44: {
        height: '44px'
    },
    selectedTabButton: { background: '#F4F6F8' },
    menuTabButton: {
        marginRight: 0,
        textDecoration: 'none',
        color: '#212121 !important',
        fontSize: '16px !important',
        fontFamily: 'Poppins-Regular',
        padding: '10px 18px 10px 8px',
        '&:hover': {
            background: '#F4F6F8 !important'
        },
        '&:focus': {
            outline: 'none'
        }
    },
    toolsButton: {
        marginRight: 0,
        textDecoration: 'none',
        color: '#212121 !important',
        fontSize: '16px !important',
        fontFamily: 'Poppins-Regular',
        padding: '16px 8px',
        display: 'flex',
        flexDirection: 'row',
        '&:hover': {
            background: '#F4F6F8 !important'
        },
        '&:focus': {
            outline: 'none'
        }
    },
    otherToolsButton: {
        padding: 0,
        marginRight: 0,
        textDecoration: 'none',
        display: 'flex',
        flexDirection: 'row',
        overflow: 'hidden',
        color: '#212121 !important',
        fontSize: '16px !important',
        fontFamily: 'Poppins-Regular',
        '&:hover': { background: '#F4F6F8 !important' },
        '&:focus': { outline: 'none' }
    },
    pricingButton: {
        height: '44px',
        padding: '10px',
        textDecoration: 'none',
        color: '#212121 !important',
        fontSize: '16px !important',
        fontFamily: 'Poppins-Regular',
        '&:focus': { outline: 'none' },
        '&:hover': { background: '#F4F6F8 !important' }
    },
    chevron: { fontSize: '22px', color: '#434242', marginLeft: '10px' },
    toolTitle: {
        fontSize: '14px',
        lineHeight: '21px',
        marginBottom: '5px',
        textTransform: 'capitalize',
        fontFamily: 'Poppins-Medium'
    },
    rotate180: {
        transform: 'rotate(180deg)'
    },
    selfCenter: {
        alignSelf: 'center'
    },
    ml_1: {
        marginLeft: '10px'
    },
    mb_1: {
        marginBottom: '10px'
    },
    open: {
        height: '111px',
        transition: 'height 0.1s ease'
    },
    close: {
        height: 0,
        transition: 'height 0.1s ease'
    },
    createDropdown: {
        left: 0,
        width: '100%',
        height: '253px',
        padding: '24px 0',
        background: '#fff',
        marginTop: '14px',
        position: 'absolute',
        overflow: 'auto',
        '&::-webkit-scrollbar': { display: 'none' },
        boxShadow: '0px 14px 32px 0px rgba(189, 193, 202, 0.46)'
    },
    child: {
        left: 0,
        padding: '18px',
        width: '100%',
        height: '98px',
        background: '#fff',
        marginTop: '14px',
        position: 'absolute',
        overflow: 'hidden',
        overflowX: 'visible',
        boxShadow: '0px 14px 32px 0px rgba(189, 193, 202, 0.46)'
    },
    createContainer: {
        left: 0,
        right: 0,
        zIndex: 1,
        margin: '0 auto',
        display: 'grid',
        position: 'absolute',
        padding: '0 24px',
        placeContent: 'center',
        maxWidth: '1600px',
        gridTemplateColumns: 'repeat(5, 1fr)'
    },
    child_container: {
        left: 0,
        right: 0,
        zIndex: 1,
        gap: '40px',
        margin: '0 auto',
        display: 'grid',
        position: 'absolute',
        padding: '0 24px',
        placeContent: 'center',
        maxWidth: '1047px',
        gridTemplateColumns: 'repeat(4, 1fr)'
    },
    opacity1: {
        display: 'grid',
        opacity: 1,
        transition: 'opacity 0.3s linear'
    },
    opacity0: {
        opacity: 0,
        display: 'none'
    },
    backgrounds: {
        background: '#f5f5f5'
    },
    pa_20: {
        padding: '20px'
    },
    mm_csoon: {
        width: '70px',
        wordBreak: 'keep-all'
    },
    csoon: {
        position: 'absolute',
        top: '15px',
        fontSize: '11px',
        color: '#333'
    },
    blury: {
        opacity: '0.6',
        filter: 'blur(2px)'
    },
    hw50: {
        height: '48px',
        width: '48px'
    },
    transform: {
        height: '70px',
        color: '#333333',
        display: 'flex',
        flexDirection: 'column',
        fontWeight: 'normal'
    },
    span: {
        fontSize: '14px',
        marginBottom: '10px'
    },
    uppercase: {
        textTransform: 'uppercase'
    },
    toolDesc: {
        margin: 0,
        fontSize: '12px',
        color: '#212121',
        lineHeight: '18px',
        fontFamily: 'Poppins-Regular',
        display: '-webkit-box',
        lineClamp: 2,
        boxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: 'break-word'
    },
    pt16: {
        paddingTop: '16px'
    }
}));
//# sourceMappingURL=mainTabs.js.map